var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelWebsite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 60,
  viewBox: "0 0 60 60",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M5 0h50c2.762 0 5 2.243 5 5v50c0 2.762-2.243 5-5 5H5c-2.762 0-5-2.243-5-5V5c0-2.762 2.243-5 5-5M4 11h52v3H4zm4-7h3v3H8zm5 0h3v3h-3zm36 0h3v3h-3zM11 26h11v3H11zm15 0h23v3H26zM11 37h15v12H11zm23 0h15v12H34z"
})));
export default SvgChannelWebsite;